/**
 * 母亲节产品墙：Tab 滚动、list/grid swiper、Show more、副标题展开、Bundle 弹窗、总价更新
 */
(function () {
  var SEL = {
    root: '[data-momday-product-showcase]',
    tab: '[data-momday-ps-tab]',
    panel: '[data-momday-ps-panel]',
    card: '[data-momday-ps-card]',
    sub2: '[data-momday-sub2]',
    sub2toggle: '[data-momday-sub2-toggle]',
    listSwiper: '.momday_ps-list-swiper',
    gridSwiper: '.momday_ps-grid-swiper',
    showMoreBtn: '[data-momday-ps-show-more]',
    bundleOpen: '[data-momday-bundle-open]',
    bundleModal: '[data-momday-bundle-modal]',
    bundleClose: '[data-momday-bundle-close]',
    bundleConfirm: '[data-momday-bundle-confirm]',
  };

  /** List / grid swiper：与 section「Auto height」一致；缺省 true（旧 HTML 无属性时） */
  function isSwiperAutoHeightEnabled(root) {
    if (!root || !root.getAttribute) return true;
    var v = root.getAttribute('data-momday-ps-swiper-autoheight');
    if (v === null || v === '') return true;
    var s = String(v).toLowerCase();
    return s !== 'false' && s !== '0';
  }

  /** Grid swiper：整卡等高（与 section默认开启一致；旧 HTML 无属性时视为 true） */
  function isGridSwiperCardEqualHeightEnabled(root) {
    if (!root || !root.getAttribute) return true;
    var v = root.getAttribute('data-momday-ps-grid-swiper-eq');
    if (v === null || v === '') return true;
    var s = String(v).toLowerCase();
    return s !== 'false' && s !== '0';
  }

  /** 清除旧版 JS 写在 .momday_ps-media--eq 上的内联 min-height（图区高度现仅由 CSS 变量控制） */
  function clearEqMediaMinHeightIn(container) {
    if (!container || !container.querySelectorAll) return;
    container.querySelectorAll('.momday_ps-media--eq').forEach(function (m) {
      m.style.minHeight = '';
    });
  }

  /**
   * 与 assets/section-common-featured-products.js 的 formatMoney 一致：只替换首个 {{...}} 占位符，其余（如尾缀 €）原样保留。
   */
  function formatMoney(cents, format) {
    var moneyFormat = '${{amount}}';
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString =
      format != null && format !== ''
        ? format
        : window.momdayProductShowcaseMoneyFormat || moneyFormat;

    if (typeof formatString !== 'string') {
      formatString = String(formatString || moneyFormat);
    }

    var ph = formatString.match(placeholderRegex);
    if (!ph) {
      return formatString;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (ph[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2, '.', ',');
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getMoneyFormat(root) {
    var raw = root.getAttribute('data-money-format');
    if (raw != null && raw !== '') return raw;
    return window.momdayProductShowcaseMoneyFormat || '{{amount}}';
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      var a = arguments;
      t = setTimeout(function () {
        fn.apply(null, a);
      }, ms);
    };
  }

  /* Grid 卡片行分组：用于 stack 区等 min-height 对齐；媒体图区等高仅由 CSS 变量控制，不在此写入 .momday_ps-media--eq */
  var ROW_TOP_EPS = 2;

  function groupCardCellsIntoRows(cells) {
    var arr = Array.prototype.slice.call(cells, 0);
    arr.sort(function (a, b) {
      var ra = a.getBoundingClientRect();
      var rb = b.getBoundingClientRect();
      if (Math.abs(ra.top - rb.top) <= ROW_TOP_EPS) return ra.left - rb.left;
      return ra.top - rb.top;
    });
    var rows = [];
    var cur = [];
    var lastTop = null;
    arr.forEach(function (cell) {
      var t = cell.getBoundingClientRect().top;
      if (lastTop !== null && Math.abs(t - lastTop) > ROW_TOP_EPS) {
        rows.push(cur);
        cur = [];
      }
      cur.push(cell);
      lastTop = t;
    });
    if (cur.length) rows.push(cur);
    return rows;
  }

  /** 同一行卡片内各「区」拉齐高度：标题 / 卖点 / 价保+价 / 站内购买 / 外链渠道 */
  var STACK_ZONE_SELECTORS = [
    '.momday_ps-stack--head',
    '.momday_ps-stack--features',
    '.momday_ps-stack--cta',
    '.momday_ps-actions',
    '.momday_ps-stack--channels',
  ];

  function stackZoneIsMeasurable(el) {
    if (!el) return false;
    var c = window.getComputedStyle(el);
    if (c.display === 'none' || c.visibility === 'hidden') return false;
    return true;
  }

  function clearStackZoneMinHeights(rootEl) {
    if (!rootEl || !rootEl.querySelectorAll) return;
    rootEl
      .querySelectorAll(
        '.momday_ps-stack--head, .momday_ps-stack--features, .momday_ps-stack--cta, .momday_ps-actions, .momday_ps-stack--channels'
      )
      .forEach(function (el) {
        el.style.minHeight = '';
      });
  }

  function equalizeStackZonesInRow(row) {
    STACK_ZONE_SELECTORS.forEach(function (sel) {
      var els = [];
      for (var r = 0; r < row.length; r++) {
        var el = row[r].querySelector(sel);
        if (stackZoneIsMeasurable(el)) els.push(el);
      }
      if (els.length < 2) return;
      var maxH = 0;
      for (var j = 0; j < els.length; j++) {
        var h = els[j].offsetHeight;
        if (h > maxH) maxH = h;
      }
      if (maxH <= 0) return;
      for (var k = 0; k < els.length; k++) els[k].style.minHeight = maxH + 'px';
    });
  }

  function equalizeGridMediaHeights(grid) {
    if (!grid) return;
    if (grid.closest('[hidden]')) return;
    var cst = window.getComputedStyle(grid);
    if (cst.display === 'none' || cst.visibility === 'hidden') return;
    clearEqMediaMinHeightIn(grid);
  }

  /** 同一行卡片：各 stack / 购买 / 渠道区拉齐 min-height（与 equalizeStackZonesInRow 一致） */
  function equalizeGridCardStacks(grid) {
    if (!grid) return;
    if (grid.closest('[hidden]')) return;
    var cst = window.getComputedStyle(grid);
    if (cst.display === 'none' || cst.visibility === 'hidden') return;

    clearStackZoneMinHeights(grid);

    var cellArr = [];
    var ch = grid.children;
    for (var i = 0; i < ch.length; i++) {
      if (ch[i].classList && ch[i].classList.contains('momday_ps-card-cell')) cellArr.push(ch[i]);
    }
    if (cellArr.length < 2) return;

    var rows = groupCardCellsIntoRows(cellArr);
    rows.forEach(equalizeStackZonesInRow);
  }

  /* Grid swiper：slidesPerView:1 时相邻 slide 常在容器外（仅靠 transform），用视口相交只能命中 1 张，永远 <2。改取 active ± 1（含侧露 peek） */
  function slideIntersectsSwiperViewport(slide, viewportEl) {
    var sr = slide.getBoundingClientRect();
    var vr = viewportEl.getBoundingClientRect();
    return sr.right > vr.left && sr.left < vr.right;
  }

  /**
   * Grid swiper：视口内同时露出的多张卡片（含侧露 peek）拉齐为同一高度。
   * 依赖 .momday_ps-canvas--grid-eq 与 flex 样式；先清全部 slide 的 min-height 再测量。
   */
  function equalizeGridSwiperCardHeights(swiperHostEl) {
    if (!swiperHostEl) return;
    if (swiperHostEl.closest('[hidden]')) return;
    var cst0 = window.getComputedStyle(swiperHostEl);
    if (cst0.display === 'none' || cst0.visibility === 'hidden') return;

    var canvas = swiperHostEl.closest('.momday_ps-canvas--grid-swiper');
    if (!canvas || !canvas.classList.contains('momday_ps-canvas--grid-eq')) return;

    var root = swiperHostEl.closest(SEL.root);
    if (!isGridSwiperCardEqualHeightEnabled(root)) return;

    var wrapper = swiperHostEl.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    var allSlides = wrapper.querySelectorAll('.swiper-slide');
    allSlides.forEach(function (sl) {
      sl.style.minHeight = '';
    });

    var sw0 = swiperHostEl.swiper;
    if (sw0 && typeof sw0.update === 'function') {
      try {
        sw0.update();
      } catch (eUp0) {}
    }

    var slides = [];
    for (var i = 0; i < wrapper.children.length; i++) {
      var slide = wrapper.children[i];
      if (!slide.classList || !slide.classList.contains('swiper-slide')) continue;
      if (slideIntersectsSwiperViewport(slide, swiperHostEl)) slides.push(slide);
    }

    if (slides.length < 2) return;

    var maxH = 0;
    for (var j = 0; j < slides.length; j++) {
      var cell = slides[j].querySelector('.momday_ps-card-cell');
      if (!cell) continue;
      var h = cell.offsetHeight;
      if (h > maxH) maxH = h;
    }
    if (maxH <= 0) return;

    for (var k = 0; k < slides.length; k++) {
      slides[k].style.minHeight = maxH + 'px';
    }
  }

  function equalizeGridSwiperMediaHeights(swiperEl) {
    if (!swiperEl) return;
    if (swiperEl.closest('[hidden]')) return;
    var cst = window.getComputedStyle(swiperEl);
    if (cst.display === 'none' || cst.visibility === 'hidden') return;
    clearEqMediaMinHeightIn(swiperEl);
  }

  /** Grid swiper：视口内（或 active±1 侧露）多张卡片的标题区、卖点区拉齐，与桌面 .momday_ps-grid 行为一致 */
  function equalizeGridSwiperCardStacks(swiperHostEl) {
    if (!swiperHostEl) return;
    if (swiperHostEl.closest('[hidden]')) return;
    var cst0 = window.getComputedStyle(swiperHostEl);
    if (cst0.display === 'none' || cst0.visibility === 'hidden') return;

    var wrapper = swiperHostEl.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    clearStackZoneMinHeights(swiperHostEl);

    var sw = swiperHostEl.swiper;
    if (sw && typeof sw.update === 'function') {
      try {
        sw.update();
      } catch (eSt0) {}
    }

    var slides = [];
    for (var i = 0; i < wrapper.children.length; i++) {
      var slide = wrapper.children[i];
      if (!slide.classList || !slide.classList.contains('swiper-slide')) continue;
      if (slideIntersectsSwiperViewport(slide, swiperHostEl)) slides.push(slide);
    }

    if (slides.length < 2 && sw && sw.slides && sw.slides.length && typeof sw.activeIndex === 'number') {
      var ai = sw.activeIndex;
      var sls = sw.slides;
      var cand = [];
      if (sls[ai]) cand.push(sls[ai]);
      if (sls[ai + 1]) cand.push(sls[ai + 1]);
      if (sls[ai - 1]) cand.push(sls[ai - 1]);
      slides = cand.filter(function (sl, idx, arr) {
        return arr.indexOf(sl) === idx;
      });
    }

    var cellArr = [];
    for (var s = 0; s < slides.length; s++) {
      var cell = slides[s].querySelector('.momday_ps-card-cell');
      if (cell) cellArr.push(cell);
    }
    if (cellArr.length < 2) return;

    var rows = groupCardCellsIntoRows(cellArr);
    rows.forEach(equalizeStackZonesInRow);
  }

  /* List swiper：清掉图区旧内联 min-height（高度由 CSS 变量控制） */
  function equalizeListSlideStackMedia(slideEl) {
    if (!slideEl) return;
    var stack = slideEl.querySelector('.momday_ps-slide-stack');
    if (!stack) return;
    clearEqMediaMinHeightIn(stack);
  }

  function getSwiperHostEl(sw) {
    if (!sw) return null;
    if (sw.el) return sw.el;
    var $e = sw.$el;
    if ($e && $e.nodeType === 1) return $e;
    if ($e && $e.length && $e[0]) return $e[0];
    return null;
  }

  function syncListSwiperFromInstance(sw, useAutoHeight) {
    if (!sw || !sw.slides || sw.slides.length === 0) return;
    var host = getSwiperHostEl(sw);
    if (host) {
      if (host.closest('[hidden]')) return;
      var cst = window.getComputedStyle(host);
      if (cst.display === 'none' || cst.visibility === 'hidden') return;
    }
    var slide = sw.slides[sw.activeIndex];
    if (!slide) return;
    equalizeListSlideStackMedia(slide);
    if (!useAutoHeight) return;
    if (typeof sw.updateAutoHeight === 'function') {
      try {
        sw.updateAutoHeight(0);
      } catch (eAh) {}
    } else if (host) {
      var wrap = host.querySelector('.swiper-wrapper');
      if (wrap) {
        var h = slide.offsetHeight;
        if (h > 0) wrap.style.height = h + 'px';
      }
    }
  }

  function syncGridSwiperFromInstance(sw, useAutoHeight) {
    if (!sw || !sw.slides || sw.slides.length === 0) return;
    var host = getSwiperHostEl(sw);
    if (!host) return;
    if (host.closest('[hidden]')) return;
    var cst = window.getComputedStyle(host);
    if (cst.display === 'none' || cst.visibility === 'hidden') return;

    equalizeGridSwiperMediaHeights(host);
    equalizeGridSwiperCardStacks(host);
    equalizeGridSwiperCardHeights(host);

    if (!useAutoHeight) {
      if (typeof sw.update === 'function') {
        try {
          sw.update();
        } catch (eUpAh) {}
      }
      return;
    }
    var slide = sw.slides[sw.activeIndex];
    if (!slide) return;
    if (typeof sw.updateAutoHeight === 'function') {
      try {
        sw.updateAutoHeight(0);
      } catch (eAh) {}
    } else {
      var wrap = host.querySelector('.swiper-wrapper');
      if (wrap) {
        var h = slide.offsetHeight;
        if (h > 0) wrap.style.height = h + 'px';
      }
    }
  }

  function syncListSwiperViewportHeight(swiperEl) {
    var sw = swiperEl.swiper;
    if (!sw) return;
    var root = swiperEl.closest(SEL.root);
    var ah = root ? isSwiperAutoHeightEnabled(root) : true;
    syncListSwiperFromInstance(sw, ah);
  }

  function syncGridSwiperViewportHeight(swiperEl) {
    var sw = swiperEl.swiper;
    if (!sw) return;
    var root = swiperEl.closest(SEL.root);
    var ah = root ? isSwiperAutoHeightEnabled(root) : true;
    syncGridSwiperFromInstance(sw, ah);
  }

  function equalizeMediaHeightsInRoot(root) {
    root.querySelectorAll('.momday_ps-grid').forEach(function (g) {
      equalizeGridMediaHeights(g);
      equalizeGridCardStacks(g);
    });
    root.querySelectorAll(SEL.gridSwiper).forEach(syncGridSwiperViewportHeight);
    root.querySelectorAll(SEL.listSwiper).forEach(syncListSwiperViewportHeight);
  }

  var debouncedEqualizeMedia = debounce(function () {
    document.querySelectorAll(SEL.root).forEach(equalizeMediaHeightsInRoot);
  }, 120);

  /** 与 showcase CSS/JS 一致：≥850px 视为桌面 */
  var SUB2_PC_MIN_WIDTH = 850;

  function parseSub2Counts(wrap) {
    var legacy = parseInt(wrap.getAttribute('data-initial-li'), 10);
    var nMb = parseInt(wrap.getAttribute('data-initial-li-mb'), 10);
    var nPc = parseInt(wrap.getAttribute('data-initial-li-pc'), 10);
    if (isNaN(nMb)) nMb = isNaN(legacy) ? 4 : legacy;
    if (isNaN(nPc)) nPc = isNaN(legacy) ? nMb : legacy;
    return { nMb: nMb, nPc: nPc };
  }

  function getCurrentSub2N(wrap) {
    var o = parseSub2Counts(wrap);
    return window.matchMedia('(min-width: ' + SUB2_PC_MIN_WIDTH + 'px)').matches ? o.nPc : o.nMb;
  }

  /**
   * @param {HTMLElement} wrap
   * @param {{ withTransitionGuard?: boolean }} options
   */
  function applySub2Layout(wrap, options) {
    options = options || {};
    var withGuard = !!options.withTransitionGuard;
    var ul = wrap.querySelector('.momday_ps-sub2');
    if (!ul) return;
    var lis = ul.querySelectorAll('li');
    var toggle = wrap.querySelector(SEL.sub2toggle);
    var n = getCurrentSub2N(wrap);
    var expanded = wrap.classList.contains('is-expanded');

    if (lis.length <= n) {
      wrap.classList.remove('momday_ps-sub2--collapsible');
      lis.forEach(function (li) {
        li.classList.remove('momday_ps-sub2-li--hide');
      });
      if (toggle) {
        toggle.hidden = true;
        toggle.setAttribute('aria-hidden', 'true');
      }
      return;
    }

    if (toggle) {
      toggle.hidden = false;
      toggle.removeAttribute('aria-hidden');
    }

    wrap.classList.add('momday_ps-sub2--collapsible');

    if (expanded) {
      lis.forEach(function (li) {
        li.classList.remove('momday_ps-sub2-li--hide');
      });
      return;
    }

    var hideLis = [];
    lis.forEach(function (li, i) {
      if (i >= n) {
        if (withGuard) li.style.transition = 'none';
        li.classList.add('momday_ps-sub2-li--hide');
        hideLis.push(li);
      } else {
        li.classList.remove('momday_ps-sub2-li--hide');
      }
    });
    if (withGuard) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          hideLis.forEach(function (li) {
            li.style.transition = '';
          });
        });
      });
    }
  }

  var debouncedViewportSync = debounce(function () {
    document.querySelectorAll(SEL.sub2).forEach(function (wrap) {
      applySub2Layout(wrap, { withTransitionGuard: false });
    });
    document.querySelectorAll(SEL.root).forEach(equalizeMediaHeightsInRoot);
  }, 120);

  function scheduleMediaHeightEqualize() {
    debouncedEqualizeMedia();
  }

  function scrollTabStrip(tabBtn, root) {
    var strip = root.querySelector('.momday_ps-tabs-strip');
    if (!strip) return;
    var cw = strip.clientWidth;
    var maxScroll = Math.max(0, strip.scrollWidth - cw);
    if (maxScroll <= 0) return;
    var mbLeft =
      window.innerWidth > 850 ? Math.min(24, cw * 0.04) : (window.innerWidth * 4.1) / 100;
    var il = tabBtn.offsetLeft;
    var target = Math.max(0, Math.min(il - mbLeft, maxScroll));
    strip.scrollTo({ left: target, behavior: 'smooth' });
  }

  /** Tab 横条：拖拽平移；勿在 pointerdown 时 setPointerCapture，否则 click 会派发到 strip、按钮点不动 */
  function initTabStripDrag(root) {
    var strip = root.querySelector('.momday_ps-tabs-strip');
    if (!strip || strip.getAttribute('data-momday-ps-tabstrip-drag') === '1') return;
    strip.setAttribute('data-momday-ps-tabstrip-drag', '1');

    var ptrId = null;
    var dragging = false;
    var dragCommitted = false;
    var startX = 0;
    var scrollLeft0 = 0;
    var TH = 6;

    function endStripDrag(e) {
      if (!dragging) return;
      if (e && ptrId != null && e.pointerId !== ptrId) return;
      var suppressClick = dragCommitted;
      dragging = false;
      ptrId = null;
      strip.classList.remove('momday_ps-tabs-strip--dragging');
      try {
        if (e && dragCommitted) strip.releasePointerCapture(e.pointerId);
      } catch (err) {}
      dragCommitted = false;
      if (suppressClick) {
        strip.setAttribute('data-momday-ps-tabstrip-noclick', '1');
        window.setTimeout(function () {
          strip.removeAttribute('data-momday-ps-tabstrip-noclick');
        }, 50);
      }
    }

    strip.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      ptrId = e.pointerId;
      dragging = true;
      dragCommitted = false;
      startX = e.clientX;
      scrollLeft0 = strip.scrollLeft;
    });

    strip.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerId !== ptrId) return;
      var dx = e.clientX - startX;
      if (!dragCommitted && Math.abs(dx) > TH) {
        dragCommitted = true;
        strip.classList.add('momday_ps-tabs-strip--dragging');
        try {
          strip.setPointerCapture(e.pointerId);
        } catch (err2) {}
      }
      if (dragCommitted) {
        strip.scrollLeft = scrollLeft0 - dx;
      }
    });

    strip.addEventListener('pointerup', endStripDrag);
    strip.addEventListener('pointercancel', endStripDrag);

    strip.addEventListener(
      'click',
      function (e) {
        if (strip.getAttribute('data-momday-ps-tabstrip-noclick') === '1') {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      },
      true
    );
  }

  function initTabs(root) {
    initTabStripDrag(root);
    var tabs = root.querySelectorAll(SEL.tab);
    var panels = root.querySelectorAll(SEL.panel);
    if (!tabs.length) return;
    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-momday-ps-tab');
        tabs.forEach(function (b) {
          b.classList.toggle('momday_ps-tab--active', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var match = p.getAttribute('data-momday-ps-panel') === key;
          p.classList.toggle('momday_ps-panel--active', match);
          p.hidden = !match;
        });
        scrollTabStrip(btn, root);
        root.querySelectorAll('.momday_ps-panel--active .momday_ps-list-swiper').forEach(function (sw) {
          if (sw.swiper) { try { sw.swiper.update(); sw.swiper.slideTo(0); } catch (e) {} }
        });
        root.querySelectorAll('.momday_ps-panel--active .momday_ps-grid-swiper').forEach(function (el) {
          if (el.swiper) { try { el.swiper.update(); el.swiper.slideTo(0); } catch (e) {} }
        });
        scheduleMediaHeightEqualize();
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            equalizeMediaHeightsInRoot(root);
          });
        });
      });
    });
  }

  function initShowMore(root) {
    root.querySelectorAll(SEL.showMoreBtn).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var canvas = btn.closest('[data-momday-ps-canvas]');
        var box = canvas ? canvas.querySelector('[data-momday-ps-grid-more]') : null;
        if (!box) return;
        box.classList.toggle('momday_ps-grid-more--collapsed');
        var collapsed = box.classList.contains('momday_ps-grid-more--collapsed');
        canvas.classList.toggle('is-expanded', !collapsed);
        btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        scheduleMediaHeightEqualize();
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            equalizeMediaHeightsInRoot(root);
          });
        });
      });
    });
  }

  function initSub2(root) {
    root.querySelectorAll(SEL.sub2).forEach(function (wrap) {
      applySub2Layout(wrap, { withTransitionGuard: true });
      var toggle = wrap.querySelector(SEL.sub2toggle);
      if (!toggle) return;
      var ul = wrap.querySelector('.momday_ps-sub2');
      if (!ul) return;
      var lis = ul.querySelectorAll('li');
      if (lis.length <= getCurrentSub2N(wrap)) return;

      toggle.addEventListener('click', function () {
        var exp = wrap.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', exp ? 'true' : 'false');
        var n = getCurrentSub2N(wrap);
        if (exp) {
          lis.forEach(function (li) {
            li.classList.remove('momday_ps-sub2-li--hide');
          });
        } else {
          lis.forEach(function (li, i) {
            if (i >= n) li.classList.add('momday_ps-sub2-li--hide');
            else li.classList.remove('momday_ps-sub2-li--hide');
          });
        }
        scheduleMediaHeightEqualize();
      });
    });
  }

  function parseCentsFromLine(line) {
    var id = line.getAttribute('data-bundle-variant-id');
    if (!id) return null;
    var p = parseInt(line.getAttribute('data-bundle-price-cents') || '0', 10);
    var c = parseInt(line.getAttribute('data-bundle-compare-cents') || String(p), 10);
    return { id: id, price: p, compare: c };
  }

  function getBundleModalEl(card) {
    var bid = card.getAttribute('data-block-id');
    if (!bid) return null;
    return document.querySelector('[data-momday-bundle-modal="' + bid + '"]');
  }

  function getBundleModalHost() {
    return document.querySelector('.main-content') || document.querySelector('#MainContent') || document.body;
  }

  /* 价格显示：读卡片上 data-selected-bundle-total-cents（confirm 时写入，支持多配件合计） */
  function renderCardPrice(card, fmt) {
    if (card.getAttribute('data-momday-price-raw-display') === 'true') return;
    var baseP = parseInt(card.getAttribute('data-main-price-cents') || '0', 10);
    var baseC = parseInt(card.getAttribute('data-main-compare-cents') || '0', 10);
    var addP  = parseInt(card.getAttribute('data-selected-bundle-total-cents') || '0', 10);
    var addC  = parseInt(card.getAttribute('data-selected-bundle-total-compare-cents') || '0', 10);
    if (isNaN(addP)) addP = 0;
    if (isNaN(addC)) addC = 0;

    var finalP = baseP + addP;
    var finalC = baseC + addC;
    var nowEl = card.querySelector('[data-momday-price-now]');
    var cmpEl = card.querySelector('[data-momday-price-compare]');
    if (nowEl) nowEl.textContent = formatMoney(finalP, fmt);
    if (cmpEl && finalC > finalP) cmpEl.textContent = formatMoney(finalC, fmt);
    else if (cmpEl) cmpEl.textContent = '';
  }

  /* ── Bundle 弹层 ─────────────────────────────────────────────── */

  /* 把上次确认的多配件选择回填到弹层 UI（打开 / 取消时调用）
     data-selected-bundle-variant / data-selected-bundle-qty 均为逗号分隔多值 */
  function applyCommittedBundleToModal(card, modal) {
    var rawVids = String(card.getAttribute('data-selected-bundle-variant') || '').trim();
    var rawQtys = String(card.getAttribute('data-selected-bundle-qty') || '').trim();
    var bVids = rawVids ? rawVids.split(',').map(function (s) { return s.trim(); }) : [];
    var bQtys = rawQtys ? rawQtys.split(',').map(function (s) { return parseInt(s.trim(), 10) || 0; }) : [];

    modal.querySelectorAll('.momday_ps-modal-line').forEach(function (li) {
      var id  = String(li.getAttribute('data-bundle-variant-id') || '').trim();
      var inp = findQtyInput(li);
      if (!inp) return;
      var idx = bVids.indexOf(id);
      if (idx >= 0 && !inp.disabled) {
        var q    = bQtys[idx] || 0;
        var maxV = parseInt(inp.getAttribute('max'), 10);
        if (!isNaN(maxV) && maxV >= 0 && q > maxV) q = maxV;
        inp.value = String(q);
      } else {
        inp.value = '0';
      }
    });
  }

  /* 优先用 data-momday-wired-id 查 input，防止主题注入替换元素后读到旧 class */
  function findQtyInput(li) {
    return li.querySelector('[data-momday-wired-id]')
        || li.querySelector('[data-momday-qty-input]')
        || li.querySelector('.momday_ps-dlg-qty');
  }

  /* 从弹层当前 UI 读取所有 qty>0 的行，返回数组（支持多配件同时选购） */
  function readDraftFromModal(modal) {
    var allWired  = modal.querySelectorAll('[data-momday-wired-id]').length;
    var allQtyInp = modal.querySelectorAll('[data-momday-qty-input]').length;
    var allCls    = modal.querySelectorAll('.momday_ps-dlg-qty').length;
    console.log('[momday-ps] readDraft input counts: wired=' + allWired + ' attr=' + allQtyInp + ' class=' + allCls);

    var lines = [];
    modal.querySelectorAll('li.momday_ps-modal-line').forEach(function (li) {
      var inp = findQtyInput(li);
      var q   = inp ? parseInt(inp.value, 10) : 0;
      console.log('[momday-ps]   row vid=' + li.getAttribute('data-bundle-variant-id')
        + ' disabled=' + (inp && inp.disabled)
        + ' qty=' + q
        + ' wiredId=' + (inp && inp.getAttribute('data-momday-wired-id'))
        + ' inDom=' + (inp && inp.isConnected));
      if (!inp || inp.disabled || isNaN(q) || q <= 0) return;
      var vid = String(li.getAttribute('data-bundle-variant-id') || '').trim();
      if (!vid) return;
      var maxV = parseInt(inp.getAttribute('max'), 10);
      if (!isNaN(maxV) && maxV >= 0 && q > maxV) q = maxV;
      lines.push({ vid: vid, qty: q, pr: parseCentsFromLine(li) });
    });

    console.log('[momday-ps] readDraftFromModal → ' + lines.length + ' line(s): '
      + lines.map(function (d) { return d.vid + 'x' + d.qty; }).join(', '));
    return lines;  /* 空数组 = 未选任何配件 */
  }

  /* 数量步进（只做 clamp + 阻止冒泡，不操作 radio，避免副作用）
     使用 data-momday-wired-id 追踪 input，防止主题注入移位后闭包引用失效 */
  function wireQtyNative(container, modal) {
    var input = container.querySelector('[data-momday-qty-input]');
    var minus = container.querySelector('[data-momday-qty-minus]');
    var plus  = container.querySelector('[data-momday-qty-plus]');
    console.log('[momday-ps] wireQtyNative bound: input=' + !!input + ' minus=' + !!minus + ' plus=' + !!plus, container);
    if (!input || !minus || !plus) return;

    /* 给 input 打唯一标识，供 step / readDraftFromModal 重查 */
    if (!input.getAttribute('data-momday-wired-id')) {
      input.setAttribute('data-momday-wired-id', 'mdy-' + Math.random().toString(36).slice(2, 7));
    }
    var wiredId = input.getAttribute('data-momday-wired-id');

    /* 每次调用时重新在 container 内查找 input（兼容 DOM 被注入移位的情况） */
    function getInput() {
      return container.querySelector('[data-momday-wired-id="' + wiredId + '"]') || input;
    }

    /* 阻止 change/input 冒泡到主题购物车监听 */
    [input, minus, plus].forEach(function (el) {
      el.addEventListener('change', function (e) { e.stopPropagation(); }, true);
      el.addEventListener('input',  function (e) { e.stopPropagation(); }, true);
    });

    function getMin() {
      var v = parseInt(getInput().getAttribute('min'), 10);
      return isNaN(v) ? 0 : v;
    }
    function getMax() {
      var v = parseInt(getInput().getAttribute('max'), 10);
      var mn = getMin();
      return (!isNaN(v) && v >= mn) ? v : 99;
    }
    function clamp() {
      var i = getInput();
      var mn = getMin(), mx = getMax();
      var v = parseInt(i.value, 10);
      if (isNaN(v)) v = mn;
      if (v < mn) v = mn;
      if (v > mx) v = mx;
      i.value = String(v);
    }
    function step(delta) {
      var i = getInput();
      var mn = getMin(), mx = getMax();
      var v = parseInt(i.value, 10);
      if (isNaN(v)) v = mn;
      v = Math.min(mx, Math.max(mn, v + delta));
      i.value = String(v);
      return { val: v, inDom: !!i.isConnected };
    }

    minus.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var i = getInput();
      var before = i.value;
      var r = step(-1);
      console.log('[momday-ps] minus clicked: ' + before + ' → ' + r.val + ' (min=' + getMin() + ') wiredId=' + wiredId + ' inDom=' + r.inDom);
    });
    plus.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var i = getInput();
      var before = i.value;
      var r = step(1);
      console.log('[momday-ps] plus clicked: ' + before + ' → ' + r.val + ' (max=' + getMax() + ') wiredId=' + wiredId + ' inDom=' + r.inDom);
    });
    input.addEventListener('change', clamp);
    input.addEventListener('input',  clamp);
    input.addEventListener('blur',   clamp);
  }

  function initBundleModals(root) {
    var fmt = getMoneyFormat(root);

    root.querySelectorAll(SEL.card).forEach(function (card) {
      var bid = card.getAttribute('data-block-id');
      if (!bid) return;
      var openBtn = card.querySelector('[data-momday-bundle-open="' + bid + '"]');
      var modal = card.querySelector('[data-momday-bundle-modal="' + bid + '"]');
      console.log('[momday-ps] card bid=' + bid + ' openBtn=' + !!openBtn + ' modal=' + !!modal);
      if (!openBtn || !modal) return;

      function openModal() {
        /* 回填上次确认状态 */
        applyCommittedBundleToModal(card, modal);
        /* 移到 .main-content 避免被裁切 */
        var host = getBundleModalHost();
        if (host && modal.parentElement !== host) host.appendChild(modal);
        modal.hidden = false;
        modal.removeAttribute('hidden');
        modal.setAttribute('aria-hidden', 'false');
        openBtn.setAttribute('aria-expanded', 'true');
        document.body.classList.add('momday_ps-modal-open');
        /* 阻止弹层内事件冒泡（只注册一次） */
        if (!modal._momdayBubbleStopped) {
          modal._momdayBubbleStopped = true;
          var box = modal.querySelector('.momday_ps-modal-box');
          if (box) {
            ['click', 'change', 'input'].forEach(function (evt) {
              box.addEventListener(evt, function (e) { e.stopPropagation(); }, false);
            });
          }
        }
      }

      function closeModal() {
        /* 关闭时把弹层 UI 恢复成上次确认的状态（撤销未确认的操作） */
        applyCommittedBundleToModal(card, modal);
        modal.hidden = true;
        modal.setAttribute('hidden', '');
        modal.setAttribute('aria-hidden', 'true');
        openBtn.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('momday_ps-modal-open');
      }

      openBtn.addEventListener('click', function () {
        if (openBtn.disabled) return;
        openModal();
      });
      modal.querySelectorAll('[data-momday-bundle-close="' + bid + '"]').forEach(function (el) {
        el.addEventListener('click', closeModal);
      });

      /* 确认按钮：读草稿 → 写卡片属性 → 直接写按钮 data-variant-id/data-quantity → 更新价格 → 关弹层
         与 section-common-featured-products.js 相同模式：confirm 时预写按钮属性，addToCart 直接读取 */
      var confirmBtn = modal.querySelector('[data-momday-bundle-confirm="' + bid + '"]');
      console.log('[momday-ps] confirmBtn found=' + !!confirmBtn + ' for bid=' + bid);
      if (confirmBtn) {
        confirmBtn.addEventListener('click', function () {
          console.log('[momday-ps] ★ confirmBtn clicked, bid=' + bid);
          var draftLines = readDraftFromModal(modal);
          var mainVid = String(card.getAttribute('data-main-variant-id') || '').trim();
          var addBtn = card.querySelector('momday-add-cart-button');
          var buyBtn = card.querySelector('momday-buy-now-button');
          console.log('[momday-ps] mainVid=' + mainVid + ' addBtn=' + !!addBtn + ' buyBtn=' + !!buyBtn + ' draftLines=' + draftLines.length);

          if (!draftLines.length) {
            /* 未选任何配件 → 仅主品 */
            console.log('[momday-ps] no bundle → reset to main product only');
            card.removeAttribute('data-selected-bundle-variant');
            card.setAttribute('data-selected-bundle-qty', '0');
            card.setAttribute('data-selected-bundle-total-cents', '0');
            card.setAttribute('data-selected-bundle-total-compare-cents', '0');
            if (mainVid) {
              if (addBtn) { addBtn.setAttribute('data-variant-id', mainVid); addBtn.setAttribute('data-quantity', '1'); }
              if (buyBtn) { buyBtn.setAttribute('data-variant-id', mainVid); buyBtn.setAttribute('data-quantity', '1'); }
            }
          } else {
            /* 一条或多条配件 */
            var bVids = draftLines.map(function (d) { return d.vid; });
            var bQtys = draftLines.map(function (d) { return String(d.qty); });
            /* 合计价格 */
            var totalP = 0, totalC = 0;
            draftLines.forEach(function (d) {
              if (d.pr) { totalP += d.pr.price * d.qty; totalC += d.pr.compare * d.qty; }
            });
            card.setAttribute('data-selected-bundle-variant', bVids.join(','));
            card.setAttribute('data-selected-bundle-qty', bQtys.join(','));
            card.setAttribute('data-selected-bundle-total-cents', String(totalP));
            card.setAttribute('data-selected-bundle-total-compare-cents', String(totalC));
            if (mainVid) {
              var ids = [mainVid].concat(bVids).join(',');
              var qs  = ['1'].concat(bQtys).join(',');
              console.log('[momday-ps] writing to addBtn → data-variant-id=' + ids + ' data-quantity=' + qs);
              if (addBtn) { addBtn.setAttribute('data-variant-id', ids); addBtn.setAttribute('data-quantity', qs); }
              if (buyBtn) { buyBtn.setAttribute('data-variant-id', ids); buyBtn.setAttribute('data-quantity', qs); }
            }
          }
          renderCardPrice(card, fmt);
          closeModal();
        });
      }

      /* 注册数量步进 */
      modal.querySelectorAll('.momday_ps-modal-line-inner').forEach(function (row) {
        row.addEventListener('mouseenter', function () { row.classList.add('is-hovered'); });
        row.addEventListener('mouseleave', function () { row.classList.remove('is-hovered'); });
        wireQtyNative(row, modal);
      });
    });

    /* 初始化各卡片价格显示 */
    root.querySelectorAll(SEL.card).forEach(function (card) {
      renderCardPrice(card, fmt);
    });
  }

  /* ── Swiper ─────────────────────────────────────────────────── */
  function initSwipers(root) {
    if (typeof Swiper === 'undefined') return;
    var ah = isSwiperAutoHeightEnabled(root);

    root.querySelectorAll(SEL.listSwiper).forEach(function (el) {
      if (el.classList.contains('momday_ps-swiper-inited')) return;
      el.classList.add('momday_ps-swiper-inited');
      var pag = el.querySelector('.momday_ps-list-pagination');
      var opts = {
        slidesPerView: 1,
        spaceBetween: 12,
        watchOverflow: true,
        autoHeight: ah,
        on: {
          init: function () {
            syncListSwiperFromInstance(this, ah);
            debouncedEqualizeMedia();
          },
          slideChangeTransitionEnd: function () {
            syncListSwiperFromInstance(this, ah);
            debouncedEqualizeMedia();
          },
          resize: function () {
            syncListSwiperFromInstance(this, ah);
            debouncedEqualizeMedia();
          },
        },
      };
      if (pag) opts.pagination = { el: pag, clickable: true };
      try {
        el.swiper = new Swiper(el, opts);
      } catch (e) {
        console.warn('Momday list Swiper', e);
      }
    });
    root.querySelectorAll(SEL.gridSwiper).forEach(function (el) {
      if (el.classList.contains('momday_ps-swiper-inited')) return;
      el.classList.add('momday_ps-swiper-inited');
      var pag = el.querySelector('.momday_ps-grid-pagination');
      var opts = {
        slidesPerView: 1,
        spaceBetween: 12,
        watchOverflow: true,
        autoHeight: ah,
        on: {
          init: function () {
            syncGridSwiperFromInstance(this, ah);
            debouncedEqualizeMedia();
          },
          slideChangeTransitionEnd: function () {
            syncGridSwiperFromInstance(this, ah);
            debouncedEqualizeMedia();
          },
          resize: function () {
            syncGridSwiperFromInstance(this, ah);
            debouncedEqualizeMedia();
          },
        },
      };
      if (pag) opts.pagination = { el: pag, clickable: true };
      try {
        el.swiper = new Swiper(el, opts);
      } catch (e) {
        console.warn('Momday grid Swiper', e);
      }
    });
  }

  function boot(root) {
    if (root.getAttribute('data-momday-ps-booted') === '1') return;
    root.setAttribute('data-momday-ps-booted', '1');
    initTabs(root);
    initShowMore(root);
    initSub2(root);
    initBundleModals(root);
    initSwipers(root);
  }

  function initAll() {
    document.querySelectorAll(SEL.root).forEach(boot);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        document.querySelectorAll(SEL.root).forEach(equalizeMediaHeightsInRoot);
      });
    });
    if (!window.__momdayPsMediaEqListeners) {
      window.__momdayPsMediaEqListeners = true;
      window.addEventListener('resize', debouncedViewportSync);
      window.addEventListener('load', debouncedEqualizeMedia);
      document.addEventListener(
        'load',
        function (e) {
          var t = e.target;
          if (t && t.tagName === 'IMG' && t.closest && t.closest(SEL.root)) debouncedEqualizeMedia();
        },
        true
      );
    }
    window.momdayProductShowcaseEqualizeMedia = function () {
      document.querySelectorAll(SEL.root).forEach(equalizeMediaHeightsInRoot);
    };
    /* 全局 capture 监听：弹层打开时，打印每次点击的真实目标 */
    document.addEventListener('click', function (e) {
      if (!document.body.classList.contains('momday_ps-modal-open')) return;
      var t = e.target;
      var chain = [];
      var cur = t;
      for (var i = 0; i < 6 && cur; i++) {
        chain.push((cur.tagName || '?') + (cur.className ? '.' + String(cur.className).split(' ')[0] : '') + (cur.id ? '#' + cur.id : ''));
        cur = cur.parentElement;
      }
      console.log('[momday-ps] MODAL CLICK target:', chain.join(' > '));
    }, true /* capture */);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
